<template>
  <a-button class="button" type="link" @click="emit('back')">
    <ArrowLeftOutlined />
    {{ backLabel }}
  </a-button>

  <section>
    <h3>{{ title }}</h3>

    <div class="content">
      <slot />
    </div>
  </section>
</template>

<script setup lang="ts">
import { ArrowLeftOutlined } from "@ant-design/icons-vue";

defineProps<{
  title: string;
  backLabel?: string;
}>();

const emit = defineEmits<{
  (e: "back"): void;
}>();
</script>

<style scoped lang="sass">
.button
  padding: 0

h3
  font-size: 20px
  font-weight: 600
  margin-bottom: 8px

// :deep(.content)
//   color: $gray-9 !important

:deep(.content ol)
  padding-left: 20px !important

:deep(.content ul)
  padding-left: 20px !important

:deep(.content img)
  width: 100%
</style>
